/* eslint-disable */
// Auto-generated by generate_constants.py. Do not edit manually.

// ─────────────────────────────────────────────────────────────────────────────
// BEDROOM TYPE MAPPING
// ─────────────────────────────────────────────────────────────────────────────
// 1PN       : B-01, A-09
// 2PN       : A-05, A-15, B-13
// 2PN_2     : B-07
// 1PN_GOC   : A-10, A-11, B-02, B-03
// 1PN+      : tất cả còn lại
// ─────────────────────────────────────────────────────────────────────────────

export const FLOOR_LAYOUTS = {
  "22": {
    "B-01": {
      "svgPath": "M3755.01 1105h-245V915h245v190Z",
      "timTuong": 43.09,
      "thongThuy": 39.36,
      "bedroomType": "1PN"
    },
    "B-02": {
      "svgPath": "M3755.01 915h-276V708h276v207Z",
      "timTuong": 50.41,
      "thongThuy": 46.24,
      "bedroomType": "1PN_GOC"
    },
    "B-03": {
      "svgPath": "M4085.01 875h-278V676h278v199Z",
      "timTuong": 49.99,
      "thongThuy": 45.73,
      "bedroomType": "1PN_GOC"
    },
    "B-04": {
      "svgPath": "M4085.01 1070h-278V875h278v195Z",
      "timTuong": 48.82,
      "thongThuy": 45.63,
      "bedroomType": "1PN+"
    },
    "B-05": {
      "svgPath": "M4085.01 1265h-278v-195h278v195Z",
      "timTuong": 48.82,
      "thongThuy": 45.63,
      "bedroomType": "1PN+"
    },
    "B-06": {
      "svgPath": "M4085.01 1460h-278v-195h278v195Z",
      "timTuong": 49.24,
      "thongThuy": 46.13,
      "bedroomType": "1PN+"
    },
    "B-07": {
      "svgPath": "M4107.01 1703h-300v-243h300v243Z",
      "timTuong": 66.31,
      "thongThuy": 60.64,
      "bedroomType": "2PN_2"
    },
    "B-08": {
      "svgPath": "M3755.01 1703h-198v-277h198v277Z",
      "timTuong": 49.46,
      "thongThuy": 45.62,
      "bedroomType": "1PN+"
    },
    "B-09": {
      "svgPath": "M3557 1703h-395v-277h395v277Z",
      "timTuong": 98.89,
      "thongThuy": 93.10,
      "bedroomType": "3PN"
    }
  },
  "3-7": {
    "A-01": {
      "svgPath": "M1198 781h198v277h-198V781Z",
      "timTuong": 49.46,
      "thongThuy": 45.48,
      "bedroomType": "1PN+"
    },
    "A-02": {
      "svgPath": "M1396 781h195v277h-195V781Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-03": {
      "svgPath": "M1591 781h195v277h-195V781Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-04": {
      "svgPath": "M1786 781h195v277h-195V781Z",
      "timTuong": 48.82,
      "thongThuy": 45.45,
      "bedroomType": "1PN+"
    },
    "A-05": {
      "svgPath": "M1981 758h242v300h-242V758Z",
      "timTuong": 66.06,
      "thongThuy": 60.40,
      "bedroomType": "2PN"
    },
    "A-06": {
      "svgPath": "M2038 1111h200v276h-200v-276Z",
      "timTuong": 49.99,
      "thongThuy": 45.25,
      "bedroomType": "1PN+"
    },
    "A-07": {
      "svgPath": "M1844 1111h194v276h-194v-276Z",
      "timTuong": 48.82,
      "thongThuy": 45.16,
      "bedroomType": "1PN+"
    },
    "A-08": {
      "svgPath": "M1646 1111h198v276h-198v-276Z",
      "timTuong": 48.90,
      "thongThuy": 45.25,
      "bedroomType": "1PN+"
    },
    "A-09": {
      "svgPath": "M1198 1379h245v190h-245v-190Z",
      "timTuong": 43.09,
      "thongThuy": 39.26,
      "bedroomType": "1PN"
    },
    "A-10": {
      "svgPath": "M1198 1569h276v207h-276v-207Z",
      "timTuong": 50.48,
      "thongThuy": 45.90,
      "bedroomType": "1PN_GOC"
    },
    "A-11": {
      "svgPath": "M867.999 1609H1146v199H867.999v-199Z",
      "timTuong": 49.99,
      "thongThuy": 45.45,
      "bedroomType": "1PN_GOC"
    },
    "A-12": {
      "svgPath": "M867.999 1414H1146v195H867.999v-195Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-13": {
      "svgPath": "M867.999 1219H1146v195H867.999v-195Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-14": {
      "svgPath": "M867.999 1024H1146v195H867.999v-195Z",
      "timTuong": 49.24,
      "thongThuy": 45.74,
      "bedroomType": "1PN+"
    },
    "A-15": {
      "svgPath": "M845.999 781H1146v243H845.999V781Z",
      "timTuong": 66.31,
      "thongThuy": 60.09,
      "bedroomType": "2PN"
    },
    "B-01": {
      "svgPath": "M3757.99 1105h-245V914.999h245V1105Z",
      "timTuong": 43.09,
      "thongThuy": 39.24,
      "bedroomType": "1PN"
    },
    "B-02": {
      "svgPath": "M3757.99 914.999h-276v-207h276v207Z",
      "timTuong": 50.41,
      "thongThuy": 45.80,
      "bedroomType": "1PN_GOC"
    },
    "B-03": {
      "svgPath": "M4087.99 874.999h-278v-199h278v199Z",
      "timTuong": 49.99,
      "thongThuy": 45.45,
      "bedroomType": "1PN_GOC"
    },
    "B-04": {
      "svgPath": "M4087.99 1070h-278V874.999h278V1070Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-05": {
      "svgPath": "M4087.99 1265h-278v-195h278v195Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-06": {
      "svgPath": "M4087.99 1460h-278v-195h278v195Z",
      "timTuong": 49.24,
      "thongThuy": 46.03,
      "bedroomType": "1PN+"
    },
    "B-07": {
      "svgPath": "M4109.99 1703h-300v-243h300v243Z",
      "timTuong": 66.31,
      "thongThuy": 60.32,
      "bedroomType": "2PN_2"
    },
    "B-08": {
      "svgPath": "M3757.99 1703h-198v-277h198v277Z",
      "timTuong": 49.46,
      "thongThuy": 45.48,
      "bedroomType": "1PN+"
    },
    "B-09": {
      "svgPath": "M3559.99 1703h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-10": {
      "svgPath": "M3364.99 1703h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-11": {
      "svgPath": "M3169.99 1703h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-12": {
      "svgPath": "M2974.99 1703h-199v-277h199v277Z",
      "timTuong": 49.94,
      "thongThuy": 45.37,
      "bedroomType": "1PN+"
    },
    "B-13": {
      "svgPath": "M2917.99 1373h-242v-299h242v299Z",
      "timTuong": 66.32,
      "thongThuy": 60.23,
      "bedroomType": "2PN"
    },
    "B-14": {
      "svgPath": "M3111.99 1373h-194v-276h194v276Z",
      "timTuong": 48.82,
      "thongThuy": 45.19,
      "bedroomType": "1PN+"
    },
    "B-15": {
      "svgPath": "M3309.99 1373h-198v-276h198v276Z",
      "timTuong": 48.91,
      "thongThuy": 45.25,
      "bedroomType": "1PN+"
    }
  },
  "14-21": {
    "B-01": {
      "svgPath": "M3757.72 1104.25h-245V914.248h245v190.002Z",
      "timTuong": 43.09,
      "thongThuy": 39.36,
      "bedroomType": "1PN"
    },
    "B-02": {
      "svgPath": "M3757.72 914.248h-276v-207h276v207Z",
      "timTuong": 50.41,
      "thongThuy": 46.14,
      "bedroomType": "1PN_GOC"
    },
    "B-03": {
      "svgPath": "M4087.72 874.248h-278v-199h278v199Z",
      "timTuong": 49.99,
      "thongThuy": 45.73,
      "bedroomType": "1PN_GOC"
    },
    "B-04": {
      "svgPath": "M4087.72 1069.25h-278V874.248h278v195.002Z",
      "timTuong": 48.82,
      "thongThuy": 45.64,
      "bedroomType": "1PN+"
    },
    "B-05": {
      "svgPath": "M4087.72 1264.25h-278v-195h278v195Z",
      "timTuong": 48.82,
      "thongThuy": 45.64,
      "bedroomType": "1PN+"
    },
    "B-06": {
      "svgPath": "M4087.72 1459.25h-278v-195h278v195Z",
      "timTuong": 49.24,
      "thongThuy": 46.13,
      "bedroomType": "1PN+"
    },
    "B-07": {
      "svgPath": "M4109.72 1702.25h-300v-243h300v243Z",
      "timTuong": 66.31,
      "thongThuy": 60.64,
      "bedroomType": "2PN_2"
    },
    "B-08": {
      "svgPath": "M3757.72 1702.25h-198v-277h198v277Z",
      "timTuong": 49.46,
      "thongThuy": 45.62,
      "bedroomType": "1PN+"
    },
    "B-09": {
      "svgPath": "M3559.72 1702.25h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.63,
      "bedroomType": "1PN+"
    },
    "B-10": {
      "svgPath": "M3364.72 1702.25h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.63,
      "bedroomType": "1PN+"
    },
    "B-11": {
      "svgPath": "M3169.72 1702.25h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.63,
      "bedroomType": "1PN+"
    },
    "B-12": {
      "svgPath": "M2974.72 1702.25h-199v-277h199v277Z",
      "timTuong": 49.94,
      "thongThuy": 45.62,
      "bedroomType": "1PN+"
    },
    "B-13": {
      "svgPath": "M2917.72 1372.25h-242v-299h242v299Z",
      "timTuong": 66.32,
      "thongThuy": 60.64,
      "bedroomType": "2PN"
    },
    "B-14": {
      "svgPath": "M3111.72 1372.25h-194v-276h194v276Z",
      "timTuong": 48.82,
      "thongThuy": 45.49,
      "bedroomType": "1PN+"
    },
    "B-15": {
      "svgPath": "M3309.72 1372.25h-198v-276h198v276Z",
      "timTuong": 48.91,
      "thongThuy": 45.33,
      "bedroomType": "1PN+"
    },
    "A-01": {
      "svgPath": "M1196.72 781.248h198v277.002h-198V781.248Z",
      "timTuong": 49.46,
      "thongThuy": 45.62,
      "bedroomType": "1PN+"
    },
    "A-02": {
      "svgPath": "M1394.72 781.248h195v277.002h-195V781.248Z",
      "timTuong": 48.82,
      "thongThuy": 45.64,
      "bedroomType": "1PN+"
    },
    "A-03": {
      "svgPath": "M1589.72 781.248h195v277.002h-195V781.248Z",
      "timTuong": 48.82,
      "thongThuy": 45.64,
      "bedroomType": "1PN+"
    },
    "A-04": {
      "svgPath": "M1784.72 781.248h195v277.002h-195V781.248Z",
      "timTuong": 48.82,
      "thongThuy": 45.49,
      "bedroomType": "1PN+"
    },
    "A-05": {
      "svgPath": "M1979.72 758.248h242v300.002h-242V758.248Z",
      "timTuong": 66.06,
      "thongThuy": 60.81,
      "bedroomType": "2PN"
    },
    "A-06": {
      "svgPath": "M2036.72 1111.25h200v276h-200v-276Z",
      "timTuong": 49.99,
      "thongThuy": 45.72,
      "bedroomType": "1PN+"
    },
    "A-07": {
      "svgPath": "M1842.72 1111.25h194v276h-194v-276Z",
      "timTuong": 48.82,
      "thongThuy": 45.48,
      "bedroomType": "1PN+"
    },
    "A-08": {
      "svgPath": "M1644.72 1111.25h198v276h-198v-276Z",
      "timTuong": 48.90,
      "thongThuy": 45.34,
      "bedroomType": "1PN+"
    },
    "A-09": {
      "svgPath": "M1196.72 1379.25h245v190h-245v-190Z",
      "timTuong": 43.09,
      "thongThuy": 39.38,
      "bedroomType": "1PN"
    },
    "A-10": {
      "svgPath": "M1196.72 1569.25h276v207h-276v-207Z",
      "timTuong": 50.48,
      "thongThuy": 46.24,
      "bedroomType": "1PN_GOC"
    },
    "A-11": {
      "svgPath": "M866.72 1609.25h278v199h-278v-199Z",
      "timTuong": 49.99,
      "thongThuy": 45.73,
      "bedroomType": "1PN_GOC"
    },
    "A-12": {
      "svgPath": "M866.72 1414.25h278v195h-278v-195Z",
      "timTuong": 48.82,
      "thongThuy": 45.63,
      "bedroomType": "1PN+"
    },
    "A-13": {
      "svgPath": "M866.72 1219.25h278v195h-278v-195Z",
      "timTuong": 48.82,
      "thongThuy": 45.63,
      "bedroomType": "1PN+"
    },
    "A-14": {
      "svgPath": "M866.72 1024.25h278v195h-278v-195Z",
      "timTuong": 49.24,
      "thongThuy": 45.87,
      "bedroomType": "1PN+"
    },
    "A-15": {
      "svgPath": "M844.72 781.248h300v243.002h-300V781.248Z",
      "timTuong": 66.31,
      "thongThuy": 60.49,
      "bedroomType": "2PN"
    }
  },
  "8-12A": {
    "B-01": {
      "svgPath": "M3758 1103h-245V913h245v190Z",
      "timTuong": 43.09,
      "thongThuy": 39.24,
      "bedroomType": "1PN"
    },
    "B-02": {
      "svgPath": "M3758 913h-276V706h276v207Z",
      "timTuong": 50.41,
      "thongThuy": 45.80,
      "bedroomType": "1PN_GOC"
    },
    "B-03": {
      "svgPath": "M4088 873h-278V674h278v199Z",
      "timTuong": 49.99,
      "thongThuy": 45.45,
      "bedroomType": "1PN_GOC"
    },
    "B-04": {
      "svgPath": "M4088 1068h-278V873h278v195Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-05": {
      "svgPath": "M4088 1263h-278v-195h278v195Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-06": {
      "svgPath": "M4088 1458h-278v-195h278v195Z",
      "timTuong": 49.24,
      "thongThuy": 46.03,
      "bedroomType": "1PN+"
    },
    "B-07": {
      "svgPath": "M4110 1701h-300v-243h300v243Z",
      "timTuong": 66.31,
      "thongThuy": 60.32,
      "bedroomType": "2PN_2"
    },
    "B-08": {
      "svgPath": "M3758 1701h-198v-277h198v277Z",
      "timTuong": 49.46,
      "thongThuy": 45.48,
      "bedroomType": "1PN+"
    },
    "B-09": {
      "svgPath": "M3560 1701h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-10": {
      "svgPath": "M3365 1701h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-11": {
      "svgPath": "M3170 1701h-195v-277h195v277Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "B-12": {
      "svgPath": "M2975 1701h-199v-277h199v277Z",
      "timTuong": 49.94,
      "thongThuy": 45.37,
      "bedroomType": "1PN+"
    },
    "B-13": {
      "svgPath": "M2918 1371h-242v-299h242v299Z",
      "timTuong": 66.32,
      "thongThuy": 60.28,
      "bedroomType": "2PN"
    },
    "B-14": {
      "svgPath": "M3112 1371h-194v-276h194v276Z",
      "timTuong": 48.82,
      "thongThuy": 45.27,
      "bedroomType": "1PN+"
    },
    "B-15": {
      "svgPath": "M3310 1371h-198v-276h198v276Z",
      "timTuong": 48.91,
      "thongThuy": 45.27,
      "bedroomType": "1PN+"
    },
    "A-01": {
      "svgPath": "M1197 781h198v277h-198V781Z",
      "timTuong": 49.46,
      "thongThuy": 45.48,
      "bedroomType": "1PN+"
    },
    "A-02": {
      "svgPath": "M1395 781h195v277h-195V781Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-03": {
      "svgPath": "M1590 781h195v277h-195V781Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-04": {
      "svgPath": "M1785 781h195v277h-195V781Z",
      "timTuong": 48.82,
      "thongThuy": 45.45,
      "bedroomType": "1PN+"
    },
    "A-05": {
      "svgPath": "M1980 758h242v300h-242V758Z",
      "timTuong": 66.06,
      "thongThuy": 60.45,
      "bedroomType": "2PN"
    },
    "A-06": {
      "svgPath": "M2037 1111h200v276h-200v-276Z",
      "timTuong": 49.99,
      "thongThuy": 45.41,
      "bedroomType": "1PN+"
    },
    "A-07": {
      "svgPath": "M1843 1111h194v276h-194v-276Z",
      "timTuong": 48.82,
      "thongThuy": 45.24,
      "bedroomType": "1PN+"
    },
    "A-08": {
      "svgPath": "M1645 1111h198v276h-198v-276Z",
      "timTuong": 48.90,
      "thongThuy": 45.28,
      "bedroomType": "1PN+"
    },
    "A-09": {
      "svgPath": "M1197 1379h245v190h-245v-190Z",
      "timTuong": 43.09,
      "thongThuy": 39.26,
      "bedroomType": "1PN"
    },
    "A-10": {
      "svgPath": "M1197 1569h276v207h-276v-207Z",
      "timTuong": 50.48,
      "thongThuy": 45.90,
      "bedroomType": "1PN_GOC"
    },
    "A-11": {
      "svgPath": "M867.003 1609H1145v199H867.003v-199Z",
      "timTuong": 49.99,
      "thongThuy": 45.45,
      "bedroomType": "1PN_GOC"
    },
    "A-12": {
      "svgPath": "M867.003 1414H1145v195H867.003v-195Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-13": {
      "svgPath": "M867.003 1219H1145v195H867.003v-195Z",
      "timTuong": 48.82,
      "thongThuy": 45.54,
      "bedroomType": "1PN+"
    },
    "A-14": {
      "svgPath": "M867.003 1024H1145v195H867.003v-195Z",
      "timTuong": 49.24,
      "thongThuy": 45.74,
      "bedroomType": "1PN+"
    },
    "A-15": {
      "svgPath": "M845.003 781H1145v243H845.003V781Z",
      "timTuong": 66.31,
      "thongThuy": 60.09,
      "bedroomType": "2PN"
    }
  }
};
